export default "__VITE_ASSET__BBzwfy0a__"